import { BooleanInput, Create, FormDataConsumer, required, SelectInput, SimpleForm, TextInput } from 'react-admin';
import AddToLokaliseButton from '../../Components/AddToLokaliseButton';

const nameChoices = [
  { id: 'vacation', name: 'vacation' },
  { id: 'medical', name: 'medical' },
  { id: 'custom', name: 'custom' },
  { id: 'overtime', name: 'overtime' },
  { id: 'scheduleAssignment', name: 'scheduleAssignment' },
  { id: 'hoursBankToExtraHoursConversion', name: 'hoursBankToExtraHoursConversion' },
  { id: 'compensatoryTimeOff', name: 'compensatoryTimeOff' }
];

const RequestTypeTemplatesCreate = () => (
  <Create redirect="list">
    <SimpleForm>
      <TextInput source="country" label="Country (2-char ISO)" inputProps={{ maxLength: 2 }} required />
      <SelectInput source="name" label="Name" choices={nameChoices} validate={required()} />
      <FormDataConsumer>{({ formData }) => <AddToLokaliseButton translationKey={formData.name} />}</FormDataConsumer>
      <BooleanInput source="active" label="Active" defaultValue={true} />
    </SimpleForm>
  </Create>
);

export default RequestTypeTemplatesCreate;
